import { ViewPreferenceContext } from "./view-preference-context";
export const ViewPreferenceConsumer = ViewPreferenceContext.Consumer;